import { wistiaEmbed } from './wistia-embed';
import { horizonText } from './horizon-text';
//import { rgbShift } from './rgb-shift';
import { solutionsComp } from './comp-solution-blocks';
import { caseStudyComp } from './comp-case-studies';
import { distortCircles } from './distort-circle';
import { filterButton } from './posts-filter';
//import { preFooter } from './pre-footer';
import { accordionComponents } from './accordions';
import { gfAjax } from './gravity-forms-ajax';
//import { caseStudyCarousel } from './case-studies-carousel';
import { postsStyleCarousel } from './posts-style-carousel';
import { statsComp } from './stats';
import { pressCarousel } from './press-carousel';


const init = (gsap, mm, scrollTrigger, smoother, Draggable, Swiper, FreeMode, Navigation, Thumbs, EffectFade, Autoplay, ScrambleTextPlugin) => {
	
	/***************************************************************
		CONVERT HASH LINKS TO SMOOTH SCROLL
	***************************************************************/
 
	document.querySelectorAll("a").forEach(function(current) {
		if(!current.hash) return;
		if(current.origin + current.pathname != self.location.href) return;
		(function(anchorPoint) {
			if(anchorPoint) {
				current.addEventListener("click", function(e) {
					smoother.scrollTo(anchorPoint, true, "top 100px");
					//anchorPoint.scrollIntoView({behavior: "smooth"});
					e.preventDefault();
				}, false);
			}
		})(document.querySelector(current.hash));
	});
	
	/*********************************************************************
		REMOVE QUOTES FROM CMS TEXT SO THAT DESIGN SPECIFIC ONES ARE USED
	*********************************************************************/

	let $quotes = $('.testimonial-block .testimonial p').add('.wp-block-quote p');
	
	if ($quotes) {
		$quotes.each(function() {
			const $this = $(this);
			const $text = $this.text();
			let cleanQuote = $text.replace(/\"|”|“/g,'');
			$this.text(cleanQuote);
		});
		
	}
	
	/***************************************************************
		HACK ( ′～‵) Make tables responsive since no horizontal scroll
	***************************************************************/
 
	let $tables = $('table');
	
	$tables.each(function() {
		
		let $this = $(this);
		let $parent = $this.parent();
		
		Draggable.create($this, {
			type:"x",
			bounds: $parent,
			inertia: true,
		});
		
	});
	
	const $tds = $('td');
	
	$tds.each(function () {
		if ($(this).html() == '') {
			$(this).addClass('empty-cell');
		}
	});
	
	/***************************************************************
		LOAD GRAVITY FORMS
	***************************************************************/
 
		gfAjax(scrollTrigger);
	
	/***************************************************************
		LOAD WISTIA VIDEOS
	***************************************************************/
	
	wistiaEmbed(scrollTrigger);
	
	/***************************************************************
		HORIZONTAL SCROLL TITLES
	***************************************************************/
	
	horizonText(gsap, mm);
	
	/***************************************************************
		RGB SHIFT IMAGE ANIMATION
	***************************************************************/
 
	//rgbShift(gsap, scrollTrigger, smoother);
	
	/***************************************************************
		SOLUTION BLOCKS ANIMATION
	***************************************************************/
 
	solutionsComp(gsap);
	
	/***************************************************************
		CASE STUDIES INLINE COMPONENT
	***************************************************************/
	
	caseStudyComp(gsap, scrollTrigger);
	
	/***************************************************************
		DISTORT CIRCLES ON HOVER
	***************************************************************/
 
	distortCircles(gsap);
	
	/***************************************************************
		ACCORDIONS
	***************************************************************/
	
	accordionComponents(gsap, scrollTrigger, smoother);
	
	/***************************************************************
		POSTS FILTERS
	***************************************************************/

	filterButton();
	
	/***************************************************************
		POSTS STYLE CAROUSEL
	***************************************************************/
	
	postsStyleCarousel(Swiper, FreeMode, Navigation);
	
	/***************************************************************
		PRE FOOTER LINK HOVERS
	***************************************************************/
 
	//preFooter(gsap);
	
	/***************************************************************
		STATS COUNTER
	***************************************************************/
	
	statsComp(gsap, scrollTrigger, ScrambleTextPlugin);
	
	/***************************************************************
		PRESS CAROUSEL
	***************************************************************/

	pressCarousel(Swiper, Navigation, Thumbs, EffectFade, Autoplay);
		
}

export {
	init
};
